module.exports = __webpack_public_path__ + "static/media/md-heart-half.f6111402.svg";